/* Bundle grid tiles: same brand tints as the rest of the site.

   Flicker notes, both fixed here:
   1. The observer watched style attributes as well as child lists. Setting
      a background is a style change, so every deal triggered another — an
      endless loop that read as blinking. It watches child lists only now
      and disconnects while it writes.
   2. A frame was re-randomised on every render, and the list re-renders on
      every pick, tier switch and filter change. Colours are remembered per
      frame, so a tile holds its colour for the life of the page.

   The frame is identified by data-vid on the card. It used to be read out
   of the onclick attribute, which broke the moment the card gained an image
   strip and the click moved onto the strip. */
(function(){
"use strict";
var TILES=["#f1f6fc","#e1d5ef","#f9e7d2","#fafe95","#f0f8f7","#fdeef2","#eef3ea","#f4f0e6"];
var MEM={};

function cols(grid){
  var t=getComputedStyle(grid).gridTemplateColumns;
  var n=(t||'').split(' ').filter(function(s){return s.trim()}).length;
  return n>0?n:1;
}
function keyOf(card){
  if(card.dataset && card.dataset.vid) return String(card.dataset.vid);
  var el=card.querySelector('[onclick]');
  return String((el && el.getAttribute('onclick')) || '').replace(/[^0-9]/g,'');
}
function deal(grid){
  var cards=[].slice.call(grid.querySelectorAll('.card')).filter(function(c){
    return c.style.display!=='none';
  });
  if(!cards.length) return;
  var c=cols(grid), row=[], i;
  for(i=0;i<cards.length;i++){
    if(i % c === 0) row=[];
    var sh=cards[i].querySelector('.sh'); if(!sh) continue;
    var key=keyOf(cards[i]);
    var want=MEM[key];
    if(!want || row.indexOf(want)>-1){
      var pool=TILES.filter(function(x){ return row.indexOf(x)<0 });
      if(!pool.length) pool=TILES.slice();
      want=pool[Math.floor(Math.random()*pool.length)];
      if(key) MEM[key]=want;
    }
    if(sh.style.background!==want) sh.style.background=want;
    if(sh.style.boxShadow!=='none') sh.style.boxShadow='none';
    row.push(want);
  }
}

document.addEventListener('DOMContentLoaded', function(){
  var grid=document.getElementById('bGrid');
  if(!grid) return;
  var obs, t=null;
  function run(){
    if(obs) obs.disconnect();
    deal(grid);
    if(obs) obs.observe(grid,{childList:true});
  }
  function schedule(){ clearTimeout(t); t=setTimeout(run, 30) }
  obs=new MutationObserver(schedule);
  obs.observe(grid,{childList:true});
  run();
  window.SFBundleTint={ refresh: schedule };
  var rt=null;
  window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(run,250) });
});
})();